function normalizeEgyptPhoneForWhatsApp(raw) {
  if (!raw) return null;

  // keep digits only
  let digits = String(raw).replace(/\D/g, '');
  if (!digits) return null;

  // If already includes country code 20
  if (digits.startsWith('20')) {
    return digits;
  }

  // If starts with 0 (typical Egyptian local format)
  if (digits.startsWith('0')) {
    return `20${digits.slice(1)}`;
  }

  // If starts with 2 (sometimes stored like 2xxxxxxxxxx)
  if (digits.startsWith('2') && digits.length >= 11) {
    return `20${digits.slice(1)}`;
  }

  // Fallback: assume Egypt
  return `20${digits}`;
}

export function buildOrderWhatsAppMessageEg(order) {
  const customerName = order?.customerName || order?.name || 'حضرتك';
  const shortId = order?.id ? String(order.id).slice(-8) : '';
  const total = order?.totalAmount ?? '';

  const items = Array.isArray(order?.items) ? order.items : [];
  const itemsList = items
    .map((item) => {
      const qty = item?.quantity || 1;
      const name = item?.name || 'منتج';
      return `${qty} × ${name}`;
    })
    .join('، ');

  return [
    `اهلا بيك يا ${customerName}`,
    `احنا من VetCare Store وبنتواصل مع حضرتك بخصوص الاوردر رقم #${shortId}`,
    itemsList ? `الطلبات: ${itemsList}` : null,
    total !== '' ? `الاجمالي: ${total} جنيه` : null,
    `ممكن تأكدلنا العنوان وميعاد الاستلام المناسب؟`,
    `شكراً ليك لاختيارك VetCare Store!`,
  ].filter(Boolean).join('\n\n');
}

export function openOrderWhatsAppEg(order) {
  const phoneRaw = order?.customerPhone || order?.phone;
  const phone = normalizeEgyptPhoneForWhatsApp(phoneRaw);
  if (!phone) return { ok: false, reason: 'no_phone' };

  const message = buildOrderWhatsAppMessageEg(order);
  const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  window.open(url, '_blank');
  return { ok: true };
}
